import React from 'react';
import {
  maxLength,
  minLength,
  required,
  TextInput,
  ArrayInput,
  SimpleFormIterator,
} from 'react-admin';
import { makeStyles, Grid, Paper, Typography } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  paperBase: {
    padding: '40px 30px',
    margin: '15px 0',
  },
  formRoot: {
    '& .MuiTextField-root': {
      width: '100%',
    },
    '& .MuiFilledInput-root': {
      backgroundColor: '#fdfdfd',
    },
  },
  pLR10: {
    padding: '0 10px',
  },
  center: {
    textAlign: 'center',
  },
}));

const validateInstruction = [required(), minLength(2), maxLength(255)];

const ChecklistForm = () => {
  const classes = useStyles();

  return (
    <Paper className={classes.paperBase}>
      <Typography variant="h5" gutterBottom>
        Technician Service Checklist
      </Typography>
      <Grid container className={classes.formRoot}>
        <Grid item xs={12} className={classes.pLR10}>
          <ArrayInput
            resource="service-offering-checklist"
            source="checklists"
            margin="normal"
          >
            <SimpleFormIterator>
              <TextInput
                resource="service-offering-checklist"
                multiline
                validate={validateInstruction}
                source="instruction"
              />
            </SimpleFormIterator>
          </ArrayInput>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default ChecklistForm;
